import ProjectedEarningsContainer from './containers/ProjectedEarningsContainer'

export default ProjectedEarningsContainer
